import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getCenterWiseResults } from '@api/getCenterWiseResults';
import { autoSlotSelector, numberLanguageFormatter } from '@utils/utils';
import { useCustomParams } from './useCustomParams';
import { CenterWiseResultsType } from '@type/centerWiseResults';

interface useCenterWiseResultsType {
  centerWisResults: {
    total: number;
    getData: any[];
    asonName: string;

    zillaName: string;
  };
  isLoading: boolean;
  handleQuery: (name: string, value: string | number) => void;
  query: {
    page: number;
    size: number;
    search: number | string;
    timeSlot: number | string;
    percentage: number | string;
  };
}

function mapCenterWiseResult(data: CenterWiseResultsType[]) {
  const results = data?.map((item: CenterWiseResultsType) => ({
    ...item,
    center_name: `${
      item?.center_serial
        ? `${numberLanguageFormatter(item?.center_serial)} -`
        : ''
    } ${item?.center_name || ''}`,
    total_voters: numberLanguageFormatter(item?.total_voters || 0),
    votes_received: numberLanguageFormatter(item?.total_vote_cast || 0),
    percentage: `${numberLanguageFormatter(item?.percentage || 0)} %`,
    className: item?.percentage
      ? `${
          item?.percentage > 0
            ? item?.percentage >= 50
              ? item?.percentage >= 80
                ? 'bg-success'
                : 'bg-info'
              : 'bg-light'
            : ''
        }`
      : '',
  }));
  return results;
}
export const useCenterWiseResults = (): useCenterWiseResultsType => {
  const [centerWisResults, setCenterWisResults] = useState<{
    total: number;
    getData: any[];
    asonName: string;
    zillaName: string;
  }>({ total: 0, getData: [], asonName: '', zillaName: '' });

  const [query, setQuery] = useState<{
    page: number;
    size: number;
    search: number | string;
    timeSlot: number | string;
    percentage: number | string;
  }>({
    page: 1,
    size: 10,
    search: '',
    percentage: '',
    timeSlot: autoSlotSelector().sendSlotRange,
  });

  const params = useParams();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { searchParams } = useCustomParams();
  const election_schedule_id = searchParams.get('election_schedule_id');

  const handleQuery = (name: string, value: string | number) => {
    setQuery((prev) => {
      return {
        ...prev,
        [`${name}`]: value,
      };
    });
  };

  useEffect(() => {
    setIsLoading(true);
    if (election_schedule_id) {
      getCenterWiseResults({
        constituencyId: params.constituencyId || '',
        ...query,
        election_schedule_id: election_schedule_id,
      })
        .then((res) => {
          const modifiedData = mapCenterWiseResult(res?.data?.centers);

          setCenterWisResults({
            total: res?.data?.count,
            getData: modifiedData,
            asonName: `${numberLanguageFormatter(res?.data?.id || '')} - ${
              res?.data?.settings_name || ''
            }`,
            zillaName: res?.data?.zilla_name || '',
          });
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
        });
    } else {
      setIsLoading(false);
    }
  }, [params.constituencyId, query, election_schedule_id]);

  return {
    query,
    isLoading,
    handleQuery,
    centerWisResults,
  };
};
